import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

export default function Verify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setFailed(true);
      return;
    }
    api
      .post("/auth/verify", { token })
      .then(() => {
        window.history.replaceState({}, "", "/members");
        navigate("/members");
      })
      .catch(() => setFailed(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="verify-page" className="min-h-screen">
      <SiteHeader />
      <main className="mx-auto max-w-xl px-6 pb-28 pt-36 text-center">
        {failed ? (
          <div data-testid="verify-failed" className="pt-16">
            <div className="mx-auto h-px w-10 bg-ochre" />
            <h1 className="mt-8 font-garamond text-4xl text-ink">
              This link is invalid or expired.
            </h1>
            <Link
              to="/login"
              data-testid="verify-retry"
              className="mt-10 inline-block border-b border-ink pb-1 font-oswald text-[11px] uppercase tracking-[0.3em] text-ink transition-colors hover:border-walnut hover:text-walnut"
            >
              Request a new link
            </Link>
          </div>
        ) : (
          <p
            data-testid="verify-pending"
            className="pt-24 font-garamond text-xl italic text-softblack/70"
          >
            Opening the door…
          </p>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
